<template>
  <Modal v-model="visible" :title="modalTitle" width="700" :footer-hide="true" :transfer="false" class="my-modal top commission-wrap" :mask-closable="false" :closable="true">
    <Form :model="formData" :label-width="130" ref="formRef" class="page-form less">
      <FormItem label="IFA" prop="owerId" :rules="$units.formRule.required('请选择IFA')">
        <Select v-model="formData.owerId" clearable filterable @on-change="onIfaChange">
          <Option v-for="item in ifaList" :value="item.id" :key="item.id">{{ item.name }}</Option>
        </Select>
      </FormItem>
      <FormItem label="保单编号" prop="policyNo">
        <Select v-model="formData.policyNo" clearable filterable :disabled="!formData.owerId" placeholder="请先选择IFA" @on-change="onPolicyChange">
          <Option v-for="item in policyList" :value="item.policyNo" :key="item.policyNo">{{ item.policyNo }}</Option>
        </Select>
      </FormItem>
      <FormItem label="积分（港币）" prop="commissionPrice" :rules="$units.formRule.required('请输入积分')">
        <Input v-model="formData.commissionPrice" :min="0" type="number" placeholder="请输入" style="width: 100%" />
      </FormItem>
      <FormItem label="收支类型" prop="incomeType" :rules="$units.formRule.required('请选择收支类型')">
        <RadioGroup v-model="formData.incomeType">
          <Radio label="1">收入</Radio>
          <Radio label="2">支出</Radio>
        </RadioGroup>
      </FormItem>
      <FormItem label="备注" prop="remark" class="full">
        <Input v-model="formData.remark" type="textarea" :rows="3" :maxlength="50" placeholder="请输入" show-word-limit />
      </FormItem>
    </Form>
    <div class="ivu-modal-footer">
      <Button type="text" @click="visible = false">取消</Button>
      <Button type="primary" @click="handleSubmit" :loading="loading">确定</Button>
    </div>
  </Modal>
</template>

<script>
const ADD_URL = '/buz/ifaExtraCommissionLog/add';
const EDIT_URL = '/buz/ifaExtraCommissionLog/edit';
const DETAIL_URL = '/buz/ifaExtraCommissionLog/read/detail';

export default {
  name: 'CommissionModal',
  props: {
    ifaList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      visible: false,
      loading: false,
      editData: null,
      policyList: [],
      formData: this.getInitialFormData()
    };
  },
  computed: {
    modalTitle() {
      return this.editData ? '编辑佣金调整' : '新增佣金调整';
    }
  },
  methods: {
    open(row) {
      this.editData = row || null;
      if (this.editData) {
        this.fetchDetail(this.editData.id);
      } else {
        this.formData = this.getInitialFormData();
        this.policyList = [];
        this.visible = true;
        this.$nextTick(() => {
          this.$refs.formRef && this.$refs.formRef.resetFields();
        });
      }
    },
    onIfaChange(val) {
      this.formData.policyNo = '';
      this.formData.policyId = '';
      this.policyList = [];
      if (!val) return;
      this.$http({
        type: 'POST',
        url: '/buz/ifaExtraCommissionLog/queryPolicyList',
        data: { agentId: val }
      }).then(res => {
        this.policyList = res.data || [];
      });
    },
    onPolicyChange(val) {
      this.formData.policyId = '';
      if (!val) return;
      const item = this.policyList.find(p => p.policyNo === val);
      if (item) {
        this.formData.policyId = item.id;
      }
    },
    fetchDetail(id) {
      this.$http({
        type: 'GET',
        url: DETAIL_URL,
        data: { id }
      }).then(res => {
        this.formData = { ...this.getInitialFormData(), ...res.data };
        this.visible = true;
        if (this.formData.owerId) {
          this.$http({
            type: 'POST',
            url: '/buz/ifaExtraCommissionLog/queryPolicyList',
            data: { agentId: this.formData.owerId }
          }).then(res2 => {
            this.policyList = res2.data || [];
          });
        }
      });
    },
    getInitialFormData() {
      return {
        owerId: '',
        policyNo: '',
        policyId: '',
        commissionPrice: '',
        incomeType: '',
        commissionType: '2',
        remark: ''
      };
    },
    handleSubmit() {
      this.$refs.formRef.validate().then(async isok => {
        if (!isok) return;
        this.loading = true;
        const url = this.editData ? EDIT_URL : ADD_URL;
        this.$http({
          type: 'POST',
          url,
          data: this.formData
        })
          .then(() => {
            this.$notice.msg(this.editData ? '编辑成功' : '新增成功');
            this.$emit('success');
            this.visible = false;
          })
          .finally(() => {
            this.loading = false;
          });
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.commission-form {
  /deep/ .ivu-row {
    .ivu-form-item {
      margin-bottom: 24px;
    }
  }
}
</style>
